import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import Ink from 'react-ink'
import { setReservationModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import { fastPayment, emptyReceipt } from '../../actions/receiptActions';
import * as properties from '../../constants/Properties'
import * as resource from '../../constants/Resources'
import Reservation from '../../components/Reservation'
import ScanReservation from '../../components/ScanReservation'
import { clearKeyboard } from '../../actions/layoutActions'

const ReservationModal = props => {
    const {
        clearKeyboard,
        fastPayment,
        emptyReceipt,
        reservationModal,
        getTranslation,
        setReservationModal
    } = props;

    const closeWindow = () => {
        clearKeyboard();
        setReservationModal(false);
        emptyReceipt();
    }

    const printTickets = () => {
        const paymentParam = reservationModal.paymentParam;

        clearKeyboard();
        setReservationModal(false);
       
        // gets receipt from server and starts payment
        // payment is skipped if open amount on receipt == 0
        // but receipt is saved, which causes tickets to be printed by serverv

        fastPayment(paymentParam);
    }

    const reservation = reservationModal.reservation;

    return (
        <Modal className='reservationModal'
            contentLabel=""
            isOpen={reservationModal.show}
            style={properties.reservationModalStyle}>

            <div className="reservationModal_header">
                <div className="header_top">
                    {reservation && getTranslation(resource.RESERVATION)}
                    <button className="header_close" onClick={closeWindow}>
                        <i className="icon remove" />
                        <Ink />
                    </button>
                </div>
            </div>
            <div className="reservationModal_content">
                {reservation ?
                    <Reservation reservation={reservation} /> :
                    <ScanReservation />
                }
            </div>
            {reservation && reservation.isCollected &&
                <div className="reservationModal-collected">
                    {getTranslation(resource.RESERVATION_COLLECTED)}
                </div>
            }
            <div className="reservationModal_footer">
                <div className="btnLeft">
                    <button className="btnCancel" onClick={closeWindow} >
                        {getTranslation(resource.CANCEL)}
                    </button>
                </div>
                {reservation && reservation.receipt.receiptType === 200 && !reservation.isCollected &&  // reservations not yet fully paid
                    <div className="btnRight">
                        <button className="btnPrintPay" onClick={printTickets} >
                            {getTranslation(resource.PRINT)}
                        </button>
                    </div>
                }
                {reservation && reservation.receipt.receiptType !== 200 && !reservation.isCollected && // paid reservations
                    <div className="btnRight">
                        <button className="btnPrintPay" onClick={printTickets} >
                            {getTranslation(resource.PAY_ORDER)}
                        </button>
                    </div>
                }
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        reservationModal: state.modalState.reservationModal
    }
}

export default connect(mapStateToProps, {
    setReservationModal,
    getTranslation,    
    clearKeyboard,
    fastPayment,
    emptyReceipt
})(ReservationModal)


// WEBPACK FOOTER //
// src/modal/components/ReservationModal.jsx